import { inject, Injectable } from '@angular/core';
import { Store } from '@ngrx/store';

import { CanvasElementId } from '@blaze-runtime/engine-domain';
import { EditOrViewDetailsAs, PageType } from '@blaze-shared/api-contracts-domain';
import { PregenerationType } from '@blaze-shared/elements-domain';

import { tryCreateRowActionPage } from './row-action-page-generation.actions';

@Injectable({ providedIn: 'root' })
export class RowActionPageGenerationFacade {
  private readonly store = inject(Store);

  private defaultPageType?: EditOrViewDetailsAs;

  tryCreateRowActionPage(
    elementId: CanvasElementId,
    config: {
      pregenerationType: PregenerationType;
      pageType?: PageType;
      actionPath: string;
      forceCreate?: boolean;
    },
  ): void {
    const pageType =
      config.pageType ?? this.defaultPageType ?? this.getDefaultPageType(config.pregenerationType);

    this.store.dispatch(
      tryCreateRowActionPage({
        elementId,
        pregenerationType: config.pregenerationType,
        pageType,
        actionPath: config.actionPath,
        forceCreate: config.forceCreate,
      }),
    );
  }

  setDefaultPageType(pageType: EditOrViewDetailsAs | undefined): void {
    this.defaultPageType = pageType;
  }

  private getDefaultPageType(pregenerationType: PregenerationType): PageType {
    if (pregenerationType === 'view') {
      return 'Page';
    }
    return 'Dialog';
  }
}
